import { useRef } from 'react'
import { Helmet } from 'react-helmet'
import { useVenueDataContext } from '@/VenueDataLoader'
import { addFacebookLogin, addGoogleLogin } from './addLoginFunctions'

export function ThirdPartyLoginInitializer() {
  const loginElementsAdded = useRef(false)
  const {
    widgetSettings: { enableSocialMediaLogin, facebookAppId },
  } = useVenueDataContext()
  if (!enableSocialMediaLogin) {
    return null
  }
  if (!loginElementsAdded.current) {
    loginElementsAdded.current = true
    if (facebookAppId) {
      addFacebookLogin(facebookAppId)
    }
    addGoogleLogin()
  }
  return (
    <Helmet>
      <script src="https://accounts.google.com/gsi/client" async defer />
      <script src="https://apis.google.com/js/client:platform.js?onload=initGoogleAPI" async defer />
    </Helmet>
  )
}
